import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const SentryPhoneService = {
    listRamal: async () => axios.get(API_KEEPER + "/phone-extensions/list").then(({ data }) => data).catch((err) => { throw err }),

    getBySipUser: async (sipUser) => axios.get(API_KEEPER + `/phone-extensions/${sipUser}`).then(({ data }) => data).catch((err) => { throw err }),

    update: async (sipUser, payload) => axios.put(API_KEEPER + `/phone-extensions/${sipUser}`, payload).then(({ data }) => data).catch((err) => { throw err }),

    destroy: async (sipUser) => axios.delete(API_KEEPER + `/phone-extensions/${sipUser}`).then(({ data }) => data).catch((err) => { throw err }),

    listAudit: async (extension) =>  axios.get(API_KEEPER + `/phone-calls`, { params: { extension } }).then(({ data }) => data).catch((err) => { throw err }),

    getAttendanceUrl: (id) => `${BASENAME}${API_DESPACHO_WEB}/attendance/form/${id}`,

    getAudio: (id, fileName) => {
        if (!id) return null;

        const params = fileName ? `?fileName=${encodeURIComponent(fileName)}` : "";

        return API_KEEPER + `/ged/attach/${id}${params}`;
    },

    downloadRecording: async (callIds) => axios.post(
        API_KEEPER + "/phone-calls/recordings/download",
        { callIds: callIds },
        { responseType: "blob" }
    ).then(({ data }) => data).catch((err) => { throw err }),
}

export default SentryPhoneService;